import { useMutation } from "@apollo/client/react";
import { UPDATE_MANUAL_RULE } from "../../mutations/aml/updateManualRule";
import GET_CLIENT_MANUAL_RULES from "../../queries/aml/getClientManualRules";

export const useUpdateManualRule = ({ onCompleted, onError }: any) => {
  const [updateManualRule, { data, loading, error }] = useMutation(
    UPDATE_MANUAL_RULE,
    {
      onCompleted: onCompleted,
      onError: onError,
      refetchQueries: [GET_CLIENT_MANUAL_RULES],
      awaitRefetchQueries: true,
    }
  );

  return { updateManualRule, data, loading, error };
};
